/**
 * axios 实例封装
 * 2022-06-23
 */

/**
 * $axios 与原生 axios 的用法相同
 *
 * config = { //额外支持的参数配置
 *    cancelFun: (cancelFunction) => {}, //取消回调函数，将中止请求的方法以参数方式传递
 *    isReturnResponse: false, //如果存在，直接返回 response 不进行错误码校验，优先级最高
 *    isResFull: false, //如果存在响应完整的返回包，否则返回 res.data ，默认否，优先级次之
 *    noHandle401: false, //如果存在，不处理 401 错误(会话失效问题)，默认否处理401，可用 noHandle401:true + handleErrCode 自定义401处理方法
 *    handleErrCode 对401(需要noHandle401:true) 429错误码的自定义处理 (code,msg,resData)=>{} code:401 | 429 ,msg:错误信息, resData:错误数据
 *    errorPop: false, //如果存在，接口报错执行，弹出toast，如果为函数将调用 (errMsg，res.body) => {}
 *    successPop: (res.body) => {}, //如果存在，接口报错执行，弹出toast，如果为函数将调用 (msg, res.body) => {}
 * }
 *
 * catch(e) { //可被捕获的错误类型
 *  if (typeof e.code === 'number') { //接口报错
 *    //e = {code: 302, info: '报错信息', data: {}}
 *    //e = {code: 302, msg: '报错信息', data: {}}
 *  } else if (e.isCancel) { //请求取消
 *    //e= {isCancel: true, message: '可选信息'}
 *  } else if (e.isError) { //通信失败
 *    //e= {isError: true, message: '未联网'}
 *  }
 * }
 */

import axios from "axios";
import Locale from "../Locale";
import Platform from "../Platform";
import { message, Modal } from "antd";
import Cookie from "../Cookie";
import Util from "../Util";
const {getExplore,getPlatform} = Util;

const CancelToken = axios.CancelToken;
const axiosInstance = axios.create({
  timeout: 10000,
  // withCredentials: true,
  headers: {
    device: "web",
    lang: Locale.getLangCode() || "en",
    "api-version": "2",
    "client-code":Cookie.get("clientCode"),
    "client-device-name": `${getExplore()} (${getPlatform()})`,
  },
});

export const setHeader = (headers) => {
  for (var key in headers)
  {
    axiosInstance.defaults.headers[key] = headers[key];
  }
}

const XtAxios = (config) => {
  const options = {
    ...(config || {}),
  };
  if (config.cancelFun && typeof config.cancelFun === "function") {
    options.cancelToken = new CancelToken(config.cancelFun);
  }

  return new Promise((resolve, reject) => {
    axiosInstance(options)
      .then((response) => {
        if (options.isReturnResponse) return resolve(response);
        //message.success(window.intl.formatMessage({id:"cmpt.depositStep"},["fdsf",1,4]));
        //message.info(Locale.intl.formatMessage({id:"ajax.test"}));

        const resData = response.data; //返回数据
				const formatResData = getFormatResData(resData);
        //接口请求成功处理
				if (formatResData.code == 200) {
					if (!Platform.isServer() && options.successPop) {
						if (typeof options.successPop === "function") {
							options.successPop(formatResData.msg, resData);
						} else {
							message.success(formatResData.msg);
						}
					}
					return resolve(options.isResFull ? resData : formatResData.data);
				}
				if (typeof resData === "object" && resData !== null) {
					resData.message = formatResData.msg;
				}
        if (Platform.isServer())
          return reject(resData);
				//401 token失效
				if (/^(302|401)$/.test(formatResData.code)) {
          if(options.noHandle401)
          {
            options.handleErrCode && options.handleErrCode(401, error.message, error.response);
            return reject(error);
          }
          else {
            window.location.href = "/" + Locale.getLangPath() + "/accounts/login?backurl="+encodeURIComponent(window.location.href);
            return reject(error);
          }
				}

				//出错了
				if (options.errorPop) {
					if (typeof options.errorPop === "function") {
						options.errorPop(formatResData.msg, resData);
					} else {
						message.error(formatResData.msg);
					}
				} else {
					console.error("【logErr】", formatResData.msg);
				}

				return reject(resData);
      })
      .catch((error) => {
        console.log(error);
        if (Platform.isServer())
          return reject(error);
				// 401
				if (error.response && /^(302|401)$/.test(error.response.status)) {
          if(options.noHandle401)
          {
            options.handleErrCode && options.handleErrCode(401, error.message, error.response);
            return reject(error);
          }
          else {
            console.error("【logErr】", error.message, options.url);
            window.location.href = "/" + Locale.getLangPath() + "/accounts/login?backurl="+encodeURIComponent(window.location.href);
            return reject(error);
          }
				}
				// 429
				if (error.response && error.response.status === 429 && !options.noHandle429) {
					console.error("【logErr】", error.message, options.url);
					options.handleErrCode && options.handleErrCode(429, error.message, error.response);
					return reject(error);
				}

				if (axios.isCancel(error)) {
					error.isCancel = true; //请求取消
					console.log("%c【axios cancel】%o", "color:#eb2f96", error);
				} else {
					error.isError = true; //通信失败
					console.log("%c【axios error】%o", "color:#eb2f96", error);
				}

				if (options.errorPop && error.message) {
					let errMsg = error.message;
					if (error.code === "ECONNABORTED" || error.message === "Network Error" || error.message.includes("timeout")) {
						errMsg = "Network Timeout";
					} else if (error.response && error.response.status === 401) {
						errMsg = `HttpReqErr: ${error.response.status}`;
					}

					if (typeof options.errorPop === "function") {
						options.errorPop(errMsg, error);
					} else{
						console.log("error.code ====", error.code);
						console.log("error.message ====", error.message);
						message.error(error.message);
					}
					console.error("【logErr pop】", error.message, options);
				} else {
					console.error("【logErr】", error.message, options.url);
				}

				return reject(error);
      })
      .finally(() => {
        // always executed
      });
  });
};
XtAxios.asyncAwait = async (func, ...rest) => {
  try {
    let data = await func(...rest);
    return { data };
  } catch (e) {
    return { err: e.message, data: e };
  }
};
const XtAxios4 = {};
XtAxios4.asyncAwait = async (func, ...rest) => {
  try {
    let data = await func(...rest);
    return { data };
  } catch (e) {
    return { err: e.message, data: e };
  }
};
["get", "delete", "head", "options"].map((method) => {
  XtAxios[method] = (url, config) => {
    const headers = {...((config || {}).headers || {})};
    if(Platform.isServer() && process.env.NEXT_PUBLIC_host)
    {
      headers["cst-root-domain"] = process.env.NEXT_PUBLIC_host.split(".").slice(-2).join(".");
    }
    return XtAxios({
      method,
      url,
      ...(config || {}),
      headers
    });
  };
  XtAxios4[method] = (url, config) => {
    const headers = {...((config || {}).headers || {})};
    headers["api-version"] = "4";
    if(Platform.isServer() && process.env.NEXT_PUBLIC_host)
    {
      headers["cst-root-domain"] = process.env.NEXT_PUBLIC_host.split(".").slice(-2).join(".");
    }
    return XtAxios({
      method,
      url,
      ...(config || {}),
      headers
    });
  };
});
["post", "put", "patch"].map((method) => {
  XtAxios[method] = (url, data, config) => {
    const headers = {...((config || {}).headers || {})};
    if(Platform.isServer() && process.env.NEXT_PUBLIC_host)
    {
      headers["cst-root-domain"] = process.env.NEXT_PUBLIC_host.split(".").slice(-2).join(".");
    }
    return XtAxios({
      method,
      url,
      data,
      ...(config || {}),
      headers
    });
  };
  XtAxios4[method] = (url, data, config) => {
    const headers = {...((config || {}).headers || {})};
    headers["api-version"] = "4";
    if(Platform.isServer() && process.env.NEXT_PUBLIC_host)
    {
      headers["cst-root-domain"] = process.env.NEXT_PUBLIC_host.split(".").slice(-2).join(".");
    }
    return XtAxios({
      method,
      url,
      data,
      ...(config || {}),
      headers
    });
  };
});
XtAxios.instance = axiosInstance;
export { XtAxios, XtAxios4 };
/**
 * 根据返回res判断接口类型
 * @param {Object} resData 
 * @returns {String}
 */
const getApiType = (resData)=>{
	if (resData.rc !== undefined) return "xt4";
	if (resData.code !== undefined && (resData.info !== undefined || resData.msg !== undefined)) return "xt3";
	if (resData.rc !== undefined && resData.code !== undefined) return "finance"; //理财
	if (resData.returnCode !== undefined) return "futures";
}
/**
 * @description 获取翻译之后的msg
 * @param {Function} t 翻译函数
 * @param {Function} te 判断key是否存在
 * @param {Sring} key 翻译key
 * @param {Object|Array｜undfined} params 翻译参数
 */
const getTransRes = (key, params)=>{
  if(Platform.isServer())
    return key;
  return Locale.intl.formatMessage({ id: key }, params);
}
/**
 * @description 统一三种接口模式下的数据格式
 * @param {Object} resData 后台返回的data数据 response.data
 * @param {Function} t 翻译函数
 * @param {Function} te 判断key是否存在
 */
const getFormatResData = (resData)=>{
	const apiType = getApiType(resData);
	const formatResData = {
		code: "",
		msg: "",
		data: null,
	};
	if (apiType === "xt4") {
		formatResData.msg = getTransRes(resData.mc, resData.ma) || resData.mc;
		formatResData.code = resData.rc === 0 ? 200 : resData.rc;
		formatResData.data = resData.result;
	} else if (apiType === "finance") {
		formatResData.msg = getTransRes(resData.mc, resData.ma) || resData.msg;
		formatResData.code = resData.code == "0" ? 200 : resData.code;
		formatResData.data = resData.data;
	} else if (apiType === "futures") {
		formatResData.code = resData.returnCode === 0 ? 200 : resData.returnCode;
		formatResData.msg =
			resData.returnCode === 0
				? getTransRes(resData.msgInfo) || resData.msgInfo
				: getTransRes(resData.error.msg) || resData.error.msg || resData.msgInfo;
		formatResData.data = resData.result;
	} else if (apiType === "xt3") {
		const defaultMsg = resData.msg || resData.info;
		formatResData.code = resData.code;
		formatResData.msg = !resData.msgInfo || !Locale.hasKey(resData.msgInfo.template)
			? defaultMsg
			: getTransRes(resData.msgInfo.template, resData.msgInfo.args) || defaultMsg;
		formatResData.data = resData.data;
	} else {
		return { ...resData };
	}
	return formatResData;
}